"use client";

import { createIcon } from "@chakra-ui/react";

const ChevronDownLightSvgIcon = createIcon({
  displayName: "ChevronDownLightSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M11.7268 14.8858L17.8463 9.27631L16.8178 8.3335L12.4541 12.3335L11.7268 12.9849L10.9996 12.3335L6.63594 8.3335L5.60742 9.27631L11.7268 14.8858Z" fill="currentColor"/>
  ),
});

export default ChevronDownLightSvgIcon;
